import { DATE_RANGE } from "~/constants";

export const formatEventDateRange = (dateRange?: TDateRange): number | undefined => {
  if (!dateRange || dateRange === DATE_RANGE.ANYTIME)
    return undefined;
  else if (dateRange === DATE_RANGE.TODAY)
    return 0;
  else if (dateRange === DATE_RANGE.YESTERDAY)
    return -1;
  else if (dateRange === DATE_RANGE.PAST_7_DAYS)
    return -7;
  else if (dateRange === DATE_RANGE.PAST_30_DAYS)
    return -30;
  else if (dateRange === DATE_RANGE.PAST_90_DAYS)
    return -90;
};
